export enum Personas {
  BUSINESS = 'business',
  LAWYER ='lawyers',
  GOVERNMENTAL ='governmental',
  INDIVIDUAL = 'individual',
  ANONYMOUS ='anonymous'
}
